export default {
  title: 'Demandes de suppression de données',
  fields: {
    created_at: 'Demandé le',
    restaurant: 'Restaurant',
    customer: 'Client',
    note: 'Note',
    status: 'Statut',
    completed_by: 'Traité par',
    actions: 'Actions',
  },
  statuses: {
    pending: 'En attente',
    completed: 'Terminé',
  },
  buttons: {
    approve: 'Approuver',
  },
  modals: {
    approve: {
      title: 'Approuver la suppression des données de {{name}} ?',
      description:
        'Cela supprime définitivement les données personnelles du client et ne peut pas être annulé. La demande sera marquée comme terminée.',
    },
  },
  toasts: {
    failed_to_load_data: 'Impossible de charger les données',
    failed_to_approve: "Impossible d'approuver la demande",
    approved: 'Demande approuvée et données supprimées',
  },
};
